import { createFileRoute } from "@tanstack/react-router";
import AdminMaterialRedirect from "@/features/lms/components/admin/AdminMaterialRedirect";

export const Route = createFileRoute("/app/admin/lms/materials/$materialId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { materialId } = Route.useParams();

  return <AdminMaterialRedirect materialId={Number(materialId)} />;
}
